import type { HomePage } from '../model/HomePage';

export const AutomationExpressAdmin: HomePage = {
    name: 'AutomationExpress',
    widgets: [ 'RecommendationTemplates', 'Automations', 'Runs' ],
    featureFlag: 'HomePage-AutomationExpress',
    persona: 'AUTOMATION_EXPRESS_ADMIN',
};
